import Navbar from "@/components/portfolio/Navbar";
import Hero from "@/components/portfolio/Hero";
import TrustedBy from "@/components/portfolio/TrustedBy";
import Marquee from "@/components/portfolio/Marquee";
import FeaturedWork from "@/components/portfolio/FeaturedWork";
import ShortFormClips from "@/components/portfolio/ShortFormClips";
import ThumbnailGallery from "@/components/portfolio/ThumbnailGallery";
import Services from "@/components/portfolio/Services";
import Flywheel from "@/components/portfolio/Flywheel";
import Stats from "@/components/portfolio/Stats";
import Process from "@/components/portfolio/Process";
import About from "@/components/portfolio/About";
import Testimonials from "@/components/portfolio/Testimonials";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";

export default function Portfolio() {
  return (
    <main data-testid="portfolio-page" className="relative bg-[#050505] text-[#F5F5F5] overflow-x-clip">
      <Navbar />
      <Hero />
      <TrustedBy />
      <Marquee />
      <FeaturedWork />
      <ShortFormClips />
      <ThumbnailGallery />
      <Services />
      <Flywheel />
      <Stats />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
